<template>
	<div class="slide-up-popup">
		<Transition name="slide-fade">
			<div v-if="show" class="slide-up-popup__content" :class="[extraClass, {'sm': store.state.isMobile.isMobile}]" tabindex="-1">
				<button class="slide-up-popup__close" :class="extraClass" @click="close">
					<img src="./close.png" alt=""/>
				</button>
				<slot></slot>
			</div>
		</Transition>
	</div>
</template>

<script setup>
import { onMounted, ref, defineProps } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const show = ref(false);
const props = defineProps({
	hideComponentHandler: {
		type: Function,
	},
	extraClass: {
		type: String,
		default: '',
	},
});
const close = () => {
	show.value = false;
	props.hideComponentHandler();
	document.body.style.overflow = 'auto';
};

onMounted(() => {
	show.value = true;
});
</script>

<style lang="scss" scoped>
@import "slide-up-popup";
</style>
